<!--
<app-page-title title="Add/Edit Product" [children]="[{title: 'Add/Edit Product'}]"></app-page-title>

<div class="container">
  <div class="row mb-5">
    <div class="col-lg-8">
      <h2 class="margin-bottom-1x">Add/Edit Product</h2>
      <form [formGroup]="productForm" (ngSubmit)="onSubmit()">
        <div class="form-group row">
          <label class="col-2 col-form-label" for="name">Product Name</label>
          <div class="col-10">
            <input class="form-control form-control-square form-control-sm" formControlName="name" type="text" id="name" value="">
            <div *ngIf="!productForm.get('name').valid && productForm.get('name').touched" class="form-control-feedback">
              Shucks, enter a name for your product.
            </div>
          </div>
        </div>

        <div class="form-group row">
          <label class="col-2 col-form-label" for="id">Id</label>
          <div class="col-10">
            <input class="form-control form-control-square form-control-sm" formControlName="id" type="number" id="id" value="0">
            <div *ngIf="!productForm.get('id').valid && productForm.get('id').touched" class="form-control-feedback">
              Shucks, enter a number as id for your product.
            </div>
          </div>
        </div>

        <div class="form-group row">
          <label class="col-2 col-form-label" for="date-input">Creation Date</label>
          <div class="col-10">
            <input class="form-control" type="date" id="date-input" formControlName="date" value="">
            <div *ngIf="!productForm.get('date').valid && productForm.get('date').touched" class="form-control-feedback">
              Shucks, enter a date for your product.
            </div>
          </div>
        </div>

        <div class="form-group row">
          <label class="col-2 col-form-label" for="categories">Categories (commma seperated)</label>
          <div class="col-10">
            <input class="form-control form-control-square form-control-sm" formControlName="categories" type="text" id="categories"
              value="">
            <div *ngIf="!productForm.get('categories').valid && productForm.get('categories').touched" class="form-control-feedback">
              Shucks, enter at least one category for your product.
            </div>
          </div>
        </div>

        <div class="form-group row">
          <label class="col-2 col-form-label" for="description">Product description</label>
          <div class="col-10">
            <textarea class="form-control form-control-square form-control-sm" formControlName="description" id="description" rows="5">
            </textarea>
            <div *ngIf="!productForm.get('description').valid && productForm.get('description').touched" class="form-control-feedback">
              Shucks, enter a description for your product.
            </div>
          </div>
        </div>

        <div class="form-group row">
          <label class="col-2 col-form-label" for="photos">Add Image</label>
          <div class="col-10">
            <input class="" type="file" id="photos" #photos>
          </div>
        </div>


        <div class="form-group row">
          <label class="col-2 col-form-label" for="price">Actual Price</label>
          <div class="col-10">
            <input class="form-control form-control-square form-control-sm" formControlName="price" type="number" id="price" value="">
            <div *ngIf="!productForm.get('price').valid && productForm.get('price').touched" class="form-control-feedback">
              Shucks, enter a price for your product.
            </div>
          </div>
        </div>

        <div class="form-group row">
          <label class="col-2 col-form-label" for="price-normal">Original Price</label>
          <div class="col-10">
            <input class="form-control form-control-square form-control-sm" formControlName="priceNormal" type="number" id="price-normal"
              value="0">
            <div *ngIf="!productForm.get('priceNormal').valid && productForm.get('priceNormal').touched" class="form-control-feedback">
              Shucks, enter a base price for your product.
            </div>
          </div>
        </div>

        <div *ngIf="fileUploadService.percentage$ | async as pct" class="progress margin-bottom-1x">
          <div class="progress-bar" role="progressbar" [style.width.%]="pct" aria-valuenow="pct | number: '1.0-0'" aria-valuemin="0"
            aria-valuemax="100">{{pct | number:'1.0-0'}}%</div>
        </div>

        <div class="row mb-5">
          <div class="col text-right">
            <button [disabled]="(mode === 'add')" class="btn btn-danger" type="button" (click)="onDelete()">Delete Product</button>
            <button [disabled]="productForm.invalid" class="btn btn-primary" type="submit">Save Changes</button>
          </div>
        </div>

      </form>

    </div>
  </div>
</div>
-->

<app-page-title title="Add/Edit Product" [children]="[{title: 'Add/Edit Product'}]"></app-page-title>

<div class="max-w-4xl mx-auto px-6 py-12">
  <div class="bg-white rounded-xl shadow-lg p-8">
    <h2 class="text-3xl font-serif text-gold mb-8">Add/Edit Product</h2>
    <form [formGroup]="productForm" (ngSubmit)="onSubmit()" class="space-y-6">
      <!-- Product Name -->
      <div class="flex items-start">
        <label class="w-32 text-lg font-serif text-gold mb-2" for="name">Product Name</label>
        <div class="flex-1">
          <input class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-gold transition duration-300"
                 formControlName="name" type="text" id="name">
          <div *ngIf="!productForm.get('name').valid && productForm.get('name').touched" class="text-red-500 text-sm mt-1">
            Shucks, enter a name for your product.
          </div>
        </div>
      </div>

      <!-- Product ID -->
      <div class="flex items-start">
        <label class="w-32 text-lg font-serif text-gold mb-2" for="id">Id</label>
        <div class="flex-1">
          <input class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-gold transition duration-300"
                 formControlName="id" type="number" id="id">
          <div *ngIf="!productForm.get('id').valid && productForm.get('id').touched" class="text-red-500 text-sm mt-1">
            Shucks, enter a number as id for your product.
          </div>
        </div>
      </div>

      <!-- Creation Date -->
      <div class="flex items-start">
        <label class="w-32 text-lg font-serif text-gold mb-2" for="date-input">Creation Date</label>
        <div class="flex-1">
          <input class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-gold transition duration-300"
                 type="date" id="date-input" formControlName="date">
          <div *ngIf="!productForm.get('date').valid && productForm.get('date').touched" class="text-red-500 text-sm mt-1">
            Shucks, enter a date for your product.
          </div>
        </div>
      </div>

      <!-- Categories -->
      <div class="flex items-start">
        <label class="w-32 text-lg font-serif text-gold mb-2" for="categories">Categories</label>
        <div class="flex-1">
          <input class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-gold transition duration-300"
                 formControlName="categories" type="text" id="categories" placeholder="Comma-separated">
          <div *ngIf="!productForm.get('categories').valid && productForm.get('categories').touched" class="text-red-500 text-sm mt-1">
            Shucks, enter at least one category for your product.
          </div>
        </div>
      </div>

      <!-- Description -->
      <div class="flex items-start">
        <label class="w-32 text-lg font-serif text-gold mb-2" for="description">Description</label>
        <div class="flex-1">
          <textarea class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-gold transition duration-300"
                    formControlName="description" id="description" rows="5"></textarea>
          <div *ngIf="!productForm.get('description').valid && productForm.get('description').touched" class="text-red-500 text-sm mt-1">
            Shucks, enter a description for your product.
          </div>
        </div>
      </div>

      <!-- Image Upload -->
      <div class="flex items-start">
        <label class="w-32 text-lg font-serif text-gold mb-2" for="photos">Add Image</label>
        <div class="flex-1">
          <input class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-gold transition duration-300"
                 type="file" id="photos" #photos>
        </div>
      </div>

      <!-- Actual Price -->
      <div class="flex items-start">
        <label class="w-32 text-lg font-serif text-gold mb-2" for="price">Actual Price</label>
        <div class="flex-1">
          <input class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-gold transition duration-300"
                 formControlName="price" type="number" id="price">
          <div *ngIf="!productForm.get('price').valid && productForm.get('price').touched" class="text-red-500 text-sm mt-1">
            Shucks, enter a price for your product.
          </div>
        </div>
      </div>

      <!-- Original Price -->
      <div class="flex items-start">
        <label class="w-32 text-lg font-serif text-gold mb-2" for="price-normal">Original Price</label>
        <div class="flex-1">
          <input class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-gold transition duration-300"
                 formControlName="priceNormal" type="number" id="price-normal">
          <div *ngIf="!productForm.get('priceNormal').valid && productForm.get('priceNormal').touched" class="text-red-500 text-sm mt-1">
            Shucks, enter a base price for your product.
          </div>
        </div>
      </div>

      <!-- Progress Bar -->
      <div *ngIf="fileUploadService.percentage$ | async as pct" class="w-full bg-gray-200 rounded-full h-4">
        <div class="bg-gold h-4 rounded-full transition-all duration-300" [style.width.%]="pct">
          <span class="text-xs text-white absolute left-1/2 transform -translate-x-1/2">{{pct | number:'1.0-0'}}%</span>
        </div>
      </div>

      <!-- Buttons -->
      <div class="flex justify-end space-x-4 mt-8">
        <button [disabled]="(mode === 'add')" class="px-6 py-3 bg-red-600 text-white rounded-lg hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 transition duration-300"
                type="button" (click)="onDelete()">Delete Product</button>
        <button [disabled]="productForm.invalid" class="px-6 py-3 bg-gold text-white rounded-lg hover:bg-gold-dark focus:outline-none focus:ring-2 focus:ring-gold transition duration-300"
                type="submit">Save Changes</button>
      </div>
    </form>
  </div>
</div>
